import axios from 'axios';

const instance = axios.create({
  baseURL: 'http://localhost:5000/api', // Base URL for your backend API
  withCredentials: true, // This is important for sending cookies (JWT)
});

export default instance;
